export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=17e61d2e&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/curacao/index.vue?vue&type=template&id=17e61d2e&scoped=true
// module id = Zn0S
// module chunks = 0